import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoanRequestCreateRequestDTO, LoanRequestDTO, LoanRequestUpdateRequestDTO, LoanRequestList, LoanRequestDeleteRequestDTO, LoanRequestReadByIdRequestDTO, LoanRequestReadByBusinessIdRequestDTO, LoanRequestReadByUserIdRequestDTO, LoanRequestReadByServiceProviderRRNRequestDTO } from './loan-request.interface';
import { LoanRequest_Create, LoanRequest_Update, LoanRequest_ReadAll, LoanRequest_Delete, LoanRequest_ReadById, LoanRequest_ReadByBusinessId, LoanRequest_ReadByUserId, LoanRequest_ReadByServiceProviderRRN } from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class LoanRequestService {

  constructor() { }
  http = inject(HttpClient)
  LoanRequest_Create(data: LoanRequestCreateRequestDTO): Observable<LoanRequestDTO> {
    return this.http.post<LoanRequestDTO>(LoanRequest_Create, data)
  }

  LoanRequest_Update(data: LoanRequestUpdateRequestDTO): Observable<LoanRequestDTO> {
    return this.http.post<LoanRequestDTO>(LoanRequest_Update, data)
  }

  LoanRequest_ReadAll(): Observable<LoanRequestList> {
    return this.http.get<LoanRequestList>(LoanRequest_ReadAll)
  }
  LoanRequest_Delete(data: LoanRequestDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(LoanRequest_Delete, data)
  }


  LoanRequest_ReadById(data: LoanRequestReadByIdRequestDTO): Observable<LoanRequestDTO> {
    return this.http.post<LoanRequestDTO>(LoanRequest_ReadById, data)
  }

  LoanRequest_ReadByBusinessId(data: LoanRequestReadByBusinessIdRequestDTO): Observable<LoanRequestList> {
    return this.http.post<LoanRequestList>(LoanRequest_ReadByBusinessId, data)
  }

  LoanRequest_ReadByUserId(data: LoanRequestReadByUserIdRequestDTO): Observable<LoanRequestList> {
    return this.http.post<LoanRequestList>(LoanRequest_ReadByUserId, data)
  }
  LoanRequest_ReadByServiceProviderRRN(data: LoanRequestReadByServiceProviderRRNRequestDTO): Observable<LoanRequestDTO> {
    return this.http.post<LoanRequestDTO>(LoanRequest_ReadByServiceProviderRRN, data)
  }
}
